module.exports = __webpack_public_path__ + "img/icon_bonus.7c18d10c.svg";